(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function initIndicators() {
    const grid = document.querySelector("#ProductGridContainer #product-grid");
    if (!grid) return;

    const medias = grid.querySelectorAll("[data-rsai-card-media]");
    medias.forEach((media) => {
      const track = media.querySelector(".rsai-card-track");
      if (!track) return;

      const slides = Array.from(track.querySelectorAll(".rsai-card-slide"));
      if (slides.length <= 1) return;

      // Remove old indicator if re-rendered
      const old = media.querySelector(".rsai-card-indicator");
      if (old) old.remove();

      // Ensure positioning context
      if (getComputedStyle(media).position === "static") {
        media.style.position = "relative";
      }

      // Build indicator
      const indicator = document.createElement("div");
      indicator.className = "rsai-card-indicator";
      const fill = document.createElement("span");
      indicator.appendChild(fill);
      media.appendChild(indicator);

      function update() {
        const total = slides.length;

        // track width is one "page"
        const pageW = track.clientWidth || 1;

        // progress from 0..(total-1)
        const rawIndex = track.scrollLeft / pageW;
        const progress = clamp(rawIndex, 0, total - 1);

        // Fill is 1/total of the track
        indicator.style.setProperty("--rsai-indicator-fill", (100 / total) + "%");

        // Move fill across the 72px bar
        const barW = indicator.clientWidth || 72;
        const fillW = barW * (1 / total);
        const maxX = barW - fillW;

        const x = (progress / (total - 1)) * maxX;
        indicator.style.setProperty("--rsai-indicator-x", x + "px");
      }

      let raf = null;
      track.addEventListener("scroll", () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          update();
        });
      });

      window.addEventListener("resize", update);
      update();
    });
  }

  document.addEventListener("DOMContentLoaded", initIndicators);
  document.addEventListener("shopify:section:load", initIndicators);
})();
